/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./layout.module.scss"
import { CommonContext, ThemeContext } from "@src/context"
import { config as wechatConfig } from "@src/utils/wechat"

const Layout = ({ children, location }) => {
  const [isMobileLayout, setIsMoibleLayout] = useState()
  useEffect(() => {
    const resizeEvent = () => {
      const winW = window.innerWidth
      setIsMoibleLayout(winW < 900)
    }
    window.addEventListener("resize", resizeEvent)
    resizeEvent()
    return () => {
      window.removeEventListener("resize", resizeEvent)
    }
  }, [])
  useEffect(() => {
    wechatConfig()
  }, [])
  return (
    <CommonContext.Provider
      value={{
        isMobileLayout,
      }}
    >
      <ThemeContext.Provider
        value={
          location && location.pathname.indexOf("/chengdu") >= 0 ? "cd" : "gz"
        }
      >
        <Seo />
        <Nav location={location} />
        <div className={styles.container}>
          <main>{children}</main>
        </div>
        <footer className={styles.footer}>
          <div className={styles.footerEmail}>
            <a href="mailto://g@gcores.com">g@gcores.com</a>
            <p>some logos here</p>
          </div>
          <div className={styles.footerRights}>
            GSENSE®️ 2020 ALL RIGHTS RESERVED
          </div>
        </footer>
      </ThemeContext.Provider>
    </CommonContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
